module.exports = __webpack_public_path__ + "img/main-banner-promo.3b5163e.png";